<template>
  <MenuPage :_categories="categories" />
</template>

<script>
import MenuPage from '@/components/pages/common/MenuPage'
import { FunctionCd, S3Root, ManualFileName } from '@/enum'

export default {
  name: 'IQCMenuPage',

  components: {
    MenuPage,
  },

  data() {
    return {
      categories: [],
    }
  },

  mounted() {
    if (!this.$store.getters.canIQC) {
      this.$router.push({ name: 'TopMenu' }).catch(() => {})
    }

    this.categories = [
      {
        name: this.$t('ELE0064'),
        size: 2,
        icon: 'mdi-text-box-edit',
        color: '#FCF4A1',
        iconColor: '#948D2B',
        items: [
          { functionCd: FunctionCd.IMPORT_INSP_INDEX, route: 'T01' },
          { functionCd: FunctionCd.SEARCH_INSP_INDEX, route: 'T02' },
          { functionCd: FunctionCd.EDIT_INSP_INDEX, route: 'T03' },
          { functionCd: FunctionCd.BOX_INFO, route: 'T04' },
          { functionCd: FunctionCd.SEARCH_INSP_BOX, route: 'T05' },
          { functionCd: FunctionCd.IMP_INSP_LOT, route: 'T14' },
          { functionCd: FunctionCd.SEARCH_INSP_LOT, route: 'T15' },
          { functionCd: FunctionCd.SEARCH_PARTS_INSP_INFO, route: 'T32' },
        ],
      },
      {
        name: this.$t('ELE0069'),
        size: 2,
        icon: 'mdi-bottle-tonic-skull',
        color: '#BBD9F3',
        iconColor: '#8BA9C3',
        items: [
          {
            functionCd: FunctionCd.SEARCH_XRF_INSP_EXPR_DT,
            route: 'T16',
          },
          {
            functionCd: FunctionCd.INPUT_XRF_INSP,
            route: 'T31',
          },
        ],
      },
      {
        name: this.$t('ELE0491'),
        size: 2,
        icon: 'mdi-stamper',
        color: '#F8D8AF',
        iconColor: '#C46200',
        items: [
          { functionCd: FunctionCd.SEARCH_MMMM_HISTORY, route: 'T29' },
          { functionCd: FunctionCd.REQUEST_MMMM, route: 'T30' },
        ],
      },
      {
        name: this.$t('ELE0065'),
        size: 2,
        icon: 'mdi-stamper',
        color: '#F8D8AF',
        iconColor: '#C46200',
        items: [
          { functionCd: FunctionCd.SEARCH_SA_HISTORY, route: 'T06' },
          { functionCd: FunctionCd.REQUEST_SA, route: 'T07' },
        ],
      },
      {
        name: this.$t('ELE0066'),
        size: 2,
        icon: 'mdi-file-edit',
        color: '#C9E0A7',
        iconColor: '#3A8A3E',
        items: [
          { functionCd: FunctionCd.SEARCH_INSP_RESULT, route: 'T09' },
          { functionCd: FunctionCd.INPUT_APP_INSP, route: 'T10' },
          { functionCd: FunctionCd.INPUT_DIM_INSP, route: 'T11' },
          { functionCd: FunctionCd.IMP_INSP_DATA_CSV, route: 'T12' },
          { functionCd: FunctionCd.EXPORT_INSP_DATA_CSV, route: 'T13' },
          { functionCd: FunctionCd.DEL_INSP_DATA, route: 'T17' },
          { functionCd: FunctionCd.ANALYZE_RECORD, route: 'T28' },
        ],
      },
      {
        name: this.$t('ELE0067'),
        size: 2,
        icon: 'mdi-hand-okay',
        color: '#DDBFE6',
        iconColor: '#9333AE',
        items: [{ functionCd: FunctionCd.APPD_INSP_DATA, route: 'T19' }],
      },
      {
        name: this.$t('ELE0068'),
        size: 2,
        icon: 'mdi-chart-bar',
        color: '#BEE6D6',
        iconColor: '#92B0A4',
        items: [
          { functionCd: FunctionCd.DEFECT_PARETO_CHART, route: 'R01' },
          { functionCd: FunctionCd.MEAS_VALUE_PLOT_CHART, route: 'R02' },
          { functionCd: FunctionCd.DAILY_REPORT_DEFECT_RATE, route: 'R03' },
          { functionCd: FunctionCd.DAILY_REPORT_INSP_LOAD, route: 'R04' },
          { functionCd: FunctionCd.INSPECTION_RESULT_SUMMARY, route: 'R05' },
        ],
      },
      {
        name: this.$t('ELE0070'),
        size: 2,
        icon: 'mdi-truck-remove',
        color: '#E6C5BE',
        iconColor: '#BFA59F',
        items: [
          { functionCd: FunctionCd.SEARCH_RETURN_RECORD, route: 'T26' },
          { functionCd: FunctionCd.EDIT_RETURN_RECORD, route: 'T27' },
        ],
      },
      {
        name: this.$t('ELE0337'),
        size: 2,
        icon: 'mdi-download',
        color: '#C9E0A7',
        iconColor: '#3A8A3E',
        isManualDownLoad: true,
        items: [{ name: this.$t('ELE0073'), filePath: S3Root.MANUAL + '/' + ManualFileName.IQC }],
      },
    ]
  },
}
</script>
